import PropTypes from "prop-types";
import classNames from "classnames";
import { quotationFlightShape } from "app/utils/propTypes";
import AmountContainer from "app/pages/.shared/AmountContainer";
import "./cabins-filter.scss";
import { FormattedMessage } from "react-intl";
import get from "lodash/get";
import { getCabinLabelMessageId } from "app/utils/i18nUtils";
import AmountSign from "app/pages/.shared/AmountSign/AmountSign";

const CabinsFilter = ({
	cabins = [],
	selectedCabin,
	onSelect,
	minUpgradePricesByCabin = {},
	includedFlight = {},
}) => {
	const tabHeaderNode = [];

	cabins.forEach(cabin => {
		const tabClass = classNames({
			"cabins-filter__header": true,
			"cabins-filter__header--selected": cabin === selectedCabin,
		});

		const minUpgradePricePerCabin = minUpgradePricesByCabin[cabin];

		const cabinMessageKey = getCabinLabelMessageId(cabin);

		tabHeaderNode.push(
			<div key={cabin} className={tabClass} onClick={() => onSelect(cabin)}>
				<div className="cabins-filter__label">
					<FormattedMessage id={cabinMessageKey} />
				</div>

				{get(includedFlight, "outbound.cabin") !== cabin && minUpgradePricePerCabin && (
					<div className="cabins-filter__upgradePrice">
						<AmountContainer
							prefix={minUpgradePricePerCabin > 0 ? <AmountSign sign="+" /> : ""}
							amount={minUpgradePricePerCabin}
						/>
					</div>
				)}
			</div>
		);
	});

	return (
		<div className="cabins-filter">
			<div className="cabins-filter__headers">{tabHeaderNode}</div>
		</div>
	);
};

CabinsFilter.propTypes = {
	includedFlight: quotationFlightShape,
	minUpgradePricesByCabin: PropTypes.object,
	cabins: PropTypes.arrayOf(PropTypes.string),
	selectedCabin: PropTypes.string,
	onSelect: PropTypes.func.isRequired,
};

export default CabinsFilter;
